import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { AbstractControl, UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { Sort } from '@angular/material/sort';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { DroitModelDTO } from 'src/app/shared/dtos/droitModelDTO';
import { SocieteNode } from 'src/app/shared/models/simple-types/societe.model';


@Component({
  selector: 'app-table-droit',
  templateUrl: './table-droit.component.html',
  styleUrls: ['./table-droit.component.scss']
})
export class TableDroitComponent implements OnChanges {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('table', { static: true }) table;
  @Input() societes: SocieteNode[];
  @Input() userForm: UntypedFormGroup;
  @Input() droits: DroitModelDTO[];
  @Output() droitOutput: EventEmitter<DroitModelDTO> = new EventEmitter<DroitModelDTO>();

  droitsForm: UntypedFormArray;
  displayedColumnsDroit: string[] = ['exploitation', 'commerce', 'fraisGeneraux', 'societe', 'CA1', 'visualiseBC', 'createBc', 'livBc', 'valid1', 'valid2', 'valid3', 'valid4', 'valid5', 'importBCAValid', 'importBCProv', 'genSage', 'userManager', 'repositoriesManager', 'action'];
  matDataSource: MatTableDataSource<AbstractControl> = new MatTableDataSource<AbstractControl>();
  length = 0;
  pageIndex = 0;
  pageSize = 25;
  droitAdmin2 = false;
  constructor(  private changeDetectorRef: ChangeDetectorRef) { }

  ngOnChanges(changes: SimpleChanges): void {
    this.reload();
  }

  reload(): void {
    this.droitsForm = this.userForm.get('droitsDTO') as UntypedFormArray;
    this.matDataSource = new MatTableDataSource<AbstractControl>(this.droitsForm.controls);
    this.matDataSource.paginator = this.paginator;
    
    
  }

  hasDroitAdmin2(idSociete: number){
    const user = JSON.parse(localStorage.getItem('CURRENT_USER'));
    if (!user) {
      return false;
    }
    var droitAdmin2 = user.droits.filter(droit =>
        (droit.niveau === 2) &&
        (droit.type.toUpperCase() === 'ADMIN') &&
        (droit.idSociete === idSociete)
    );
    return (droitAdmin2 && droitAdmin2.length > 0)
  }

  onDeleteRow(event): void {
    this.droitOutput.emit(event.value);
  }

  onDisabled(element): boolean {
    if (this.societes && this.societes.find(soc => soc.code === element.get('codeSociete').value) === undefined) {
      return true;
    }
    return false;
  }

  sortData(sort: Sort) {
    this.droitsForm.controls.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'societe':
          return compare(a.get('codeSociete').value, b.get('codeSociete').value, isAsc);
        case 'CA1':
          return compare(a.get('codeCa1').value, b.get('codeCa1').value, isAsc);
        default:
          return 0;
      }
    });
    this.matDataSource = new MatTableDataSource<AbstractControl>(this.droitsForm.controls);
    this.matDataSource.paginator = this.paginator;
  }

  isRowHighlighted(row: any): boolean {
    const refuseValue = row.get('refuse')?.value;
    this.changeDetectorRef.markForCheck();

    return refuseValue === true;
  }
}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}